import { DataConsts } from "./../../../models/DataConsts";
import { ImportGarantie } from "../../../models/ImportGarantie";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, Input, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-item-garantie",
  templateUrl: "./item-garantie.component.html",
  styleUrls: ["./item-garantie.component.scss"],
})
export class ItemGarantieComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ImportGarantie>;

  @Input("importGaranties")
  set data(value: ImportGarantie[]) {
    this.dataSource = new MatTableDataSource<ImportGarantie>(value);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  favorability: string = DataConsts.FAVORABILITY;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
    "id",
    "codeDossier",
    "typeGarantie",
    "montantGarantie",
    "ponderationFinale",
    "emetteurGarantie",
    "libelleSegmentPrudentielEmetteur",
    "favorability",
  ];

  constructor() {}

  ngOnInit() {}
}
